import React from "react";
import { RiLockLine, RiUserLine } from "react-icons/ri";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

interface AccountSettingsProps {
  userEmail: string | undefined;
  onChangePassword: () => void;
}

export const AccountSettings: React.FC<AccountSettingsProps> = ({
  userEmail,
  onChangePassword,
}) => {
  return (
    <div className="rounded-xl p-6 border bg-card">
      <div className="flex flex-col space-y-6">
        <div className="flex items-center gap-2">
          <RiUserLine className="w-5 h-5 text-blue-500" />
          <h2 className="text-xl font-semibold">Account Settings</h2>
        </div>

        <div className="space-y-4">
          <div className="space-y-2">
            <Label>Email</Label>
            <Input
              value={userEmail}
              readOnly
              className="bg-background/50 cursor-default opacity-70"
            />
          </div>

          <Button onClick={onChangePassword} className="w-fit">
            <RiLockLine className="mr-2" />
            Change Password
          </Button>
        </div>
      </div>
    </div>
  );
};
